import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {getFaqSearchList} from '@/api/help';
import {FaqSearchListResponse} from '@/api/help/type';
import {UseGetFaqListResult} from './useGetFaqList';

interface UseGetFaqSearchListProps {
  limit?: number;
  page: number;
  searchWord: string;
  enabled?: boolean;
}

export const useGetFaqSearchList = (
  {limit, page, searchWord, enabled}: UseGetFaqSearchListProps,
  option?: Omit<
    UseQueryOptions<FaqSearchListResponse, Error, unknown>,
    'queryKey' | 'queryFn' | 'select'
  >,
): UseGetFaqListResult => {
  const {isMobile} = useHelpContext();

  return useQuery({
    queryKey: ['help', 'faqSearch', 'list', limit, searchWord, page],
    queryFn: () => getFaqSearchList({limit, page, searchWord}),
    select: ({data}) => ({
      faqList: data.faqList.map((item) => ({
        ...item,
        title: item.title.replace(/&#32;/g, ''), // 공백 문자 변환
      })),
      count: data.faqCount,
      totalPages: Math.ceil(data.faqCount / 10),
      currentPage: page,
    }),
    enabled: (enabled || !isMobile) && !!searchWord,
    ...option,
  });
};
